"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const axios_1 = __importDefault(require("axios"));
const Auth_1 = require("./Auth");
const Logger_1 = require("./Logger");
function Api({ baseURL = "", apiKey = "" }) {
    if (!apiKey || !baseURL) {
        throw Error("API config must have baseUrl or apiKey defined");
    }
    // create instance
    const apiInstance = axios_1.default.create({
        baseURL,
        headers: {
            "x-api-key": apiKey,
        },
    });
    /* interceptors */
    // Authorization header request interceptor
    apiInstance.interceptors.request.use((config) => {
        const tokenConfig = config;
        if (tokenConfig.authenticate && (tokenConfig === null || tokenConfig === void 0 ? void 0 : tokenConfig.headers)) {
            const token = Auth_1.AuthStore.getAccessToken();
            if (!token) {
                throw new Error("Api: Unauthorized, no accessToken found");
            }
            (0, Logger_1.logDebug)("Api: ", "setting auth header");
            tokenConfig.headers.Authorization = `Bearer ${token}`;
            return tokenConfig;
        }
        return tokenConfig;
    }, (error) => {
        (0, Logger_1.logError)(error);
        return Promise.reject(error);
    });
    // logs response info
    apiInstance.interceptors.response.use((res) => {
        (0, Logger_1.logDebug)(`${res.config.url}`, `${res.status} ${res.statusText} `);
        return res;
    }, (error) => {
        (0, Logger_1.logError)(error);
        return Promise.reject(error);
    });
    return apiInstance;
}
exports.Api = Api;
//# sourceMappingURL=Api.js.map